import React from 'react';

import { ToggleButtonGroup } from '@/uiKit/atoms/ToggleButtonGroup.tsx';
import { AtomProps } from '@/uiKit/atoms/utils/AtomTypes.ts';
import { BoldToggleButton } from '@/uiKit/molecules/RichText/inputs/BoldToggleButton.tsx';
import { ItalicToggleButton } from '@/uiKit/molecules/RichText/inputs/ItalicToggleButton.tsx';
import { TextColorPickerButton } from '@/uiKit/molecules/RichText/inputs/TextColorPickerButton.tsx';
import { UnderlinedToggleButton } from '@/uiKit/molecules/RichText/inputs/UnderlinedToggleButton.tsx';

export type FormattingTypes = 'bold' | 'italic' | 'underlined';

export type BaseRichTextFormattingButtonsProps = {
  toggled: Record<FormattingTypes, boolean>;
  onToggle: (type: FormattingTypes) => void;
  color: string;
  onSelectColor: (color: string) => void;
};

export type RichTextFormattingButtonsProps =
  AtomProps<BaseRichTextFormattingButtonsProps>;

export const RichTextFormattingButtons: React.FC<
  RichTextFormattingButtonsProps
> = ({ toggled, onToggle, color, onSelectColor, ...props }) => {
  return (
    <ToggleButtonGroup {...props}>
      <BoldToggleButton
        id="rich-text-editor-bold-button"
        toggled={toggled.bold}
        onToggle={() => onToggle('bold')}
      />
      <ItalicToggleButton
        id="rich-text-editor-italic-button"
        toggled={toggled.italic}
        onToggle={() => onToggle('italic')}
      />
      <UnderlinedToggleButton
        id="rich-text-editor-underlined-button"
        toggled={toggled.underlined}
        onToggle={() => onToggle('underlined')}
      />
      <TextColorPickerButton
        id="rich-text-editor-text-color-button"
        color={color}
        onSelectColor={onSelectColor}
      />
    </ToggleButtonGroup>
  );
};
